export const LOAD_WIDGET = 'neo-trading/dashboard/LOAD_WIDGET';
export const LOAD_WIDGET_SUCCESS = 'neo-trading/dashboard/LOAD_WIDGET_SUCCESS';
export const LOAD_WIDGET_FAILURE = 'neo-trading/dashboard/LOAD_WIDGET_FAILURE';
export const EDIT_DASHBOARD = 'neo-trading/dashboard/EDIT_DASHBOARD';
export const SAVE_WIDGET_ACTIONS = 'neo-trading/dashboard/SAVE_WIDGET_ACTIONS';
export const SAVE_WIDGET_ACTIONS_SUCCESS = 'neo-trading/dashboard/SAVE_WIDGET_ACTIONS_SUCCESS';
export const SAVE_WIDGET_ACTIONS_FAILURE = 'neo-trading/dashboard/SAVE_WIDGET_ACTIONS_FAILURE';
export const SUCCESS_CHANGE_WIDGETS = 'neo-trading/dashboard/SUCCESS_CHANGE_WIDGETS';
export const SUCCESS_DELETION = 'neo-trading/dashboard/SUCCESS_DELETION';
export const ADD_SAMPLE_WIDGET = 'neo-trading/dashboard/ADD_SAMPLE_WIDGET';
export const IS_CMDTY_SELECTED = 'neo-trading/tradepanel/IS_CMDTY_SELECTED';
export const HIDE_POPOUT = 'neo-trading/tradepanel/HIDE_POPOUT';
export const SESSION_TIMEOUT = 'neo-trading/tradepanel/SESSION_TIMEOUT';
export const LOAD_TEMPLIST = 'neo-trading/dashboard/LOAD_TEMPLIST';
export const LOAD_TEMPLIST_SUCCESS= 'neo-trading/dashboard/LOAD_TEMPLIST_SUCCESS';
export const LOAD_TEMPLIST_FAILURE = 'neo-trading/dashboard/LOAD_TEMPLIST_FAILURE';
export const LAYOUT_CHANGE_STATUS = 'neo-trading/dashboard/LAYOUT_CHANGE_STATUS';
export const DEFAULT_COMMODITYPAIR = 'neo-trading/dashboard/DEFAULT_COMMODITYPAIR';
export const UPDATE_CAN_LOGOUT = 'neo-trading/dashboard/UPDATE_CAN_LOGOUT';
export const UPDATE_TRADEBOOK_COLUMNS = 'neo-trading/dashboard/UPDATE_TRADEBOOK_COLUMNS';
export const HANDLE_SETTING_MODAL='neo-trading/dashboard/HANDLE_SETTING_MODAL';
export const LOAD_TEMPLATE = 'neo-trading/dashboard/LOAD_TEMPLATE';
export const HANDLE_BM_MODAL='neo-trading/dashboard/HANDLE_BM_MODAL';
export const HANDLE_LMT_MODAL='neo-trading/dashboard/HANDLE_LMT_MODAL';
export const CHANGE_ADDWIDGETFLAG='neo-trading/dashboard/CHANGE_ADDWIDGETFLAG';
export const HANDLE_LAYOUT_FLAGMODAL='neo-trading/dashboard/HANDLE_LAYOUT_FLAGMODAL';
export const LOAD_TEMP_FLAG='neo-trading/dashboard/LOAD_TEMP_FLAG';
export const CHANGE_COMMDTY = 'neo-trading/tradepanel/CHANGE_COMMDTY';
export const ENABLE_TOOLTIP = 'neo-trading/dashboard/ENABLE_TOOLTIP';
export const LOAD_ACCOUNT='neo-trading/dashboard/LOAD_ACCOUNT';
export const LOAD_ACCOUNT_SUCCESS='neo-trading/dashboard/LOAD_ACCOUNT_SUCCESS';
export const LOAD_ACCOUNT_FAILURE='neo-trading/dashboard/LOAD_ACCOUNT_FAILURE';
export const MARGIN_LAYOUT='neo-trading/dashboard/MARGIN_LAYOUT';
export const CLOSE_LMT_MODAL='neo-trading/dashboard/CLOSE_LMT_MODAL';
export const INSTRUMENT_LAYOUT='neo-trading/dashboard/INSTRUMENT_LAYOUT';
export const TRADEBOOK_LAYOUT='neo-trading/dashboard/TRADEBOOK_LAYOUT';
export const CHART_LAYOUT='neo-trading/dashboard/CHART_LAYOUT';
export const TRADEPANEL_LAYOUT='neo-trading/dashboard/TRADEPANEL_LAYOUT';
export const CHANGE_LOGOUT_FLAG='neo-trading/dashboard/CHANGE_LOGOUT_FLAG';
export const LOAD_LANGUAGES = 'neo-trading/dashboard/LOAD_LANGUAGES';
export const LOAD_LANGUAGES_SUCCESS= 'neo-trading/dashboard/LOAD_LANGUAGES_SUCCESS';
export const LOAD_LANGUAGES_FAILURE = 'neo-trading/dashboard/LOAD_LANGUAGES_FAILURE';
export const OPEN_LAYOUTMODAL_FLAG = 'neo-trading/dashboard/OPEN_LAYOUTMODAL_FLAG';
export const SHOW_PROFILE_FLAG = 'neo-trading/dashboard/SHOW_PROFILE_FLAG';
export const TRADE_WIDGET_COUNT = 'neo-trading/dashboard/TRADE_WIDGET_COUNT';
export const DELETE_LAYOUT = 'neo-trading/dashboard/DELETE_LAYOUT';
export const DELETE_LAYOUT_SUCCESS = 'neo-trading/dashboard/DELETE_LAYOUT_SUCCESS';
export const DELETE_LAYOUT_FAILURE = 'neo-trading/dashboard/DELETE_LAYOUT_FAILURE';
export const CHANGE_CHART_COMMDTY = 'neo-trading/tradepanel/CHANGE_CHART_COMMDTY';
export const GET_VERSION_NUMBER = 'neo-trading/dashboard/GET_VERSION_NUMBER';
export const GET_VERSION_NUMBER_SUCCESS = 'neo-trading/dashboard/GET_VERSION_NUMBER_SUCCESS';
export const GET_VERSION_NUMBER_FAILURE = 'neo-trading/dashboard/GET_VERSION_NUMBER_FAILURE';
export const GET_FIXING_EVENTS = 'neo-trading/dashboard/GET_FIXING_EVENTS';
export const GET_FIXING_EVENTS_SUCCESS = 'neo-trading/dashboard/GET_FIXING_EVENTS_SUCCESS';
export const GET_FIXING_EVENTS_FAILURE = 'neo-trading/dashboard/GET_FIXING_EVENTS_FAILURE';
export const CHART_API_FLAG='neo-trading/dashboard/CHART_API_FLAG';
export const LOAD_STKCODELIST = 'neo-trading/dashboard/LOAD_STKCODELIST';
export const LOAD_STKCODELIST_SUCCESS= 'neo-trading/dashboard/LOAD_STKCODELIST_SUCCESS';
export const LOAD_STKCODELIST_FAILURE = 'neo-trading/dashboard/LOAD_STKCODELIST_FAILURE';
export const CLOSE_FIX_MODAL='neo-trading/dashboard/CLOSE_FIX_MODAL';
export const GET_VALID_FIXINGORDERS = 'neo-trading/dashboard/GET_VALID_FIXINGORDERS';
export const GET_VALID_FIXINGORDERSR_SUCCESS = 'neo-trading/dashboard/GET_VALID_FIXINGORDERS_SUCCESS';
export const GET_VALID_FIXINGORDERS_FAILURE = 'neo-trading/dashboard/GET_VALID_FIXINGORDERS_FAILURE';
export const HANDLE_FIX_MODAL='neo-trading/dashboard/HANDLE_FIX_MODAL';
export const LOAD_BIOMETRIC_DEVICE = 'neo-trading/dashboard/LOAD_BIOMETRIC_DEVICE';
export const LOAD_BIOMETRIC_DEVICE_SUCCESS= 'neo-trading/dashboard/LOAD_BIOMETRIC_DEVICE_SUCCESS';
export const LOAD_BIOMETRIC_DEVICE_FAILURE = 'neo-trading/dashboard/LOAD_BIOMETRIC_DEVICE_FAILURE';
export const LOAD_BIOMETRIC_DRESGISTER_DEVICE="neo-trading/dashboard/LOAD_BIOMETRIC_DRESGISTER_DEVICE";
export const LOAD_BIOMETRIC_DRESGISTER_DEVICE_SUCCESS="neo-trading/dashboard/LOAD_BIOMETRIC_DRESGISTER_DEVICE_SUCCESS";
export const LOAD_BIOMETRIC_DRESGISTER_DEVICE_FAILURE="neo-trading/dashboard/LOAD_BIOMETRIC_DRESGISTER_DEVICE_FAILURE";
export const LOADING_ON = 'neo-trading/auth/LOADING_ON';
export const LOADING_OFF = 'neo-trading/auth/LOADING_OFF';
export const IS_INITIAL_API_LOADED='neo-trading/IS_INITIAL_API_LOADED';
